'use client';

import { motion } from 'framer-motion';
import { BadgeCheck, Diamond, PieChart, Shield } from 'lucide-react';
import { VALUE_PROPS } from '@/lib/constants';

const iconMap = {
  Shield,
  Diamond,
  BadgeCheck,
  PieChart,
};

export function ValuePropsGrid() {
  return (
    <section className="container-page py-20 sm:py-24">
      <div className="mx-auto max-w-3xl text-center">
        <motion.h2
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          className="heading-display text-3xl text-cream sm:text-4xl lg:text-5xl"
        >
          Por qué este curso{' '}
          <span className="text-gold-gradient">cambia tu perspectiva</span>
        </motion.h2>
        <p className="mt-4 text-lg text-cream/65">
          Las cuatro razones por las que el oro lleva 5.000 años siendo la
          reserva de valor más estable de la humanidad.
        </p>
      </div>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {VALUE_PROPS.map((vp, i) => {
          const Icon = iconMap[vp.icon as keyof typeof iconMap] ?? Shield;
          return (
            <motion.article
              key={vp.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              whileHover={{ y: -6 }}
              className="ring-card group relative rounded-2xl border border-white/10 bg-navy-900/50 p-6 backdrop-blur-md hover:border-gold-500/40 hover:shadow-gold-glow"
            >
              <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-gradient-to-br from-gold-600/20 via-gold-500/10 to-transparent">
                <Icon className="h-6 w-6 text-gold-400" />
              </div>
              <h3 className="mt-5 font-display text-xl font-semibold leading-tight text-cream">
                {vp.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-cream/65">
                {vp.description}
              </p>
              <div className="absolute inset-x-6 bottom-0 h-px bg-gradient-to-r from-transparent via-gold-500/40 to-transparent opacity-0 transition-opacity group-hover:opacity-100" />
            </motion.article>
          );
        })}
      </div>
    </section>
  );
}
